import api from '../interceptors/axiosInterceptor'
import API_CONFIG from '../config'

const ORDER_ENDPOINTS = {
  // سفارشات
  GET_ALL: '/orders',
  GET_BY_ID: '/orders',           // /orders/{id}
  CREATE: '/orders',
  UPDATE: '/orders',              // /orders/{id}
  DELETE: '/orders',              // /orders/{id}
  CANCEL: '/orders/cancel',       // /orders/cancel/{id}
  
  // سفارشات کاربر
  MY_ORDERS: '/orders/my',
  MY_ORDER_DETAIL: '/orders/my',  // /orders/my/{id}
  
  // سفارشات فروشگاه
  SHOP_ORDERS: '/orders/shop',    // /orders/shop/{shopId}
  UPDATE_STATUS: '/orders/status', // /orders/status/{id}
  
  // آیتم‌های سفارش
  ORDER_ITEMS: '/orders/items',   // /orders/{orderId}/items
  ADD_ITEM: '/orders/items',      // /orders/{orderId}/items
  UPDATE_ITEM: '/orders/items',   // /orders/{orderId}/items/{itemId}
  REMOVE_ITEM: '/orders/items',   // /orders/{orderId}/items/{itemId}
  
  // جستجو و فیلتر
  SEARCH: '/orders/search',
  FILTER: '/orders/filter',
  
  // آمار و گزارشات
  STATS: '/orders/stats',
  DAILY_STATS: '/orders/stats/daily',
  MONTHLY_STATS: '/orders/stats/monthly',
  
  // پیگیری سفارش
  TRACKING: '/orders/tracking',   // /orders/tracking/{trackingNumber}
  UPDATE_TRACKING: '/orders/tracking/update'
}

const OrderService = {
  // دریافت همه سفارشات (برای ادمین)
  async getAllOrders(params = {}) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${ORDER_ENDPOINTS.GET_ALL}`,
        { params }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت سفارش توسط ID
  async getOrderById(orderId) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${ORDER_ENDPOINTS.GET_BY_ID}/${orderId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // ایجاد سفارش جدید
  async createOrder(orderData) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${ORDER_ENDPOINTS.CREATE}`,
        orderData
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // بروزرسانی سفارش
  async updateOrder(orderId, orderData) {
    try {
      const response = await api.put(
        `${API_CONFIG.BASE_URL}${ORDER_ENDPOINTS.UPDATE}/${orderId}`,
        orderData
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // حذف سفارش
  async deleteOrder(orderId) {
    try {
      const response = await api.delete(
        `${API_CONFIG.BASE_URL}${ORDER_ENDPOINTS.DELETE}/${orderId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // لغو سفارش
  async cancelOrder(orderId, reason) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${ORDER_ENDPOINTS.CANCEL}/${orderId}`,
        { reason }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت سفارشات کاربر جاری
  async getMyOrders(params = {}) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${ORDER_ENDPOINTS.MY_ORDERS}`,
        { params }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت جزئیات سفارش کاربر
  async getMyOrderDetail(orderId) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${ORDER_ENDPOINTS.MY_ORDER_DETAIL}/${orderId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت سفارشات یک فروشگاه
  async getShopOrders(shopId, params = {}) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${ORDER_ENDPOINTS.SHOP_ORDERS}/${shopId}`,
        { params }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // بروزرسانی وضعیت سفارش
  async updateOrderStatus(orderId, status, notes = '') {
    try {
      const response = await api.patch(
        `${API_CONFIG.BASE_URL}${ORDER_ENDPOINTS.UPDATE_STATUS}/${orderId}`,
        { status, notes }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت آیتم‌های سفارش
  async getOrderItems(orderId) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${ORDER_ENDPOINTS.ORDER_ITEMS}/${orderId}/items`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // افزودن آیتم به سفارش
  async addOrderItem(orderId, itemData) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${ORDER_ENDPOINTS.ADD_ITEM}/${orderId}/items`,
        itemData
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // بروزرسانی آیتم سفارش
  async updateOrderItem(orderId, itemId, itemData) {
    try {
      const response = await api.put(
        `${API_CONFIG.BASE_URL}${ORDER_ENDPOINTS.UPDATE_ITEM}/${orderId}/items/${itemId}`,
        itemData
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // حذف آیتم از سفارش
  async removeOrderItem(orderId, itemId) {
    try {
      const response = await api.delete(
        `${API_CONFIG.BASE_URL}${ORDER_ENDPOINTS.REMOVE_ITEM}/${orderId}/items/${itemId}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // جستجوی سفارشات
  async searchOrders(query, filters = {}) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${ORDER_ENDPOINTS.SEARCH}`,
        {
          params: { q: query, ...filters }
        }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // فیلتر سفارشات
  async filterOrders(filters) {
    try {
      const response = await api.post(
        `${API_CONFIG.BASE_URL}${ORDER_ENDPOINTS.FILTER}`,
        filters
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // آمار سفارشات
  async getOrderStats(timeRange = 'month') {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${ORDER_ENDPOINTS.STATS}`,
        { params: { range: timeRange } }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // آمار روزانه سفارشات
  async getDailyStats(startDate, endDate) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${ORDER_ENDPOINTS.DAILY_STATS}`,
        { params: { startDate, endDate } }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // آمار ماهانه سفارشات
  async getMonthlyStats(year, month) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${ORDER_ENDPOINTS.MONTHLY_STATS}`,
        { params: { year, month } }
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // پیگیری سفارش
  async trackOrder(trackingNumber) {
    try {
      const response = await api.get(
        `${API_CONFIG.BASE_URL}${ORDER_ENDPOINTS.TRACKING}/${trackingNumber}`
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // بروزرسانی اطلاعات پیگیری
  async updateTracking(orderId, trackingData) {
    try {
      const response = await api.put(
        `${API_CONFIG.BASE_URL}${ORDER_ENDPOINTS.UPDATE_TRACKING}/${orderId}`,
        trackingData
      )
      return response.data
    } catch (error) {
      throw this.handleError(error)
    }
  },

  // دریافت وضعیت‌های ممکن سفارش
  async getOrderStatuses() {
    return [
      { id: 'pending', name: 'در انتظار پرداخت', color: 'warning' },
      { id: 'paid', name: 'پرداخت شده', color: 'info' },
      { id: 'processing', name: 'در حال پردازش', color: 'primary' },
      { id: 'shipped', name: 'ارسال شده', color: 'success' },
      { id: 'delivered', name: 'تحویل داده شده', color: 'success' },
      { id: 'cancelled', name: 'لغو شده', color: 'error' },
      { id: 'refunded', name: 'مرجوع شده', color: 'error' }
    ]
  },

  handleError(error) {
    if (error.response) {
      return {
        message: error.response.data.message || 'خطا در مدیریت سفارش',
        status: error.response.status,
        data: error.response.data
      }
    } else if (error.request) {
      return {
        message: 'اتصال به سرور برقرار نشد',
        status: 0
      }
    } else {
      return {
        message: 'خطای ناشناخته رخ داده است',
        status: -1
      }
    }
  }
}

export default OrderService